import { Ref } from "react";

// Aplikuje ref nezávisle na tom, jestli je v normální nebo callback formě
// https://github.com/mitchellhamilton/apply-ref#readme
export const applyRef = <T>(draft: Ref<T>, value: T | null) => {
  if (typeof draft === "object" && draft !== null) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (draft.current as any) = value;
  }
  if (typeof draft === "function") {
    draft(value);
  }
};

export const applyRefs =
  <T>(...refs: Ref<T>[]) =>
  (value: T | null) => {
    refs.forEach((ref) => applyRef(ref, value));
  };
